import { Injectable } from '@angular/core';

import { SupportedLanguages } from '../../requesters/profile/preferences.model';
import { LanguagePreference } from '../domain/user-preference';

@Injectable({
	providedIn: 'root',
})
export class AppAdapter {
	public readonly languageMapping: { [k: string]: LanguagePreference } = {
		[SupportedLanguages.BROWSER]: LanguagePreference.Browser,
		[SupportedLanguages.FR]: LanguagePreference.Fr,
		[SupportedLanguages.EN]: LanguagePreference.En,
	};

	public constructor() {}
}
